import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/visitador_medico/generar_poliza';
import GenerarPoliza from './GenerarPoliza';

const ms2p = (state) => {
  return {
    ...state.vm_generar_poliza,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(GenerarPoliza);
